import { Component, NgZone, OnInit } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FreelancerDataService } from '../../../services/freelancer-data.service';
import { ToastrService } from 'ngx-toastr';
import { DomainService } from '../../domain/domain.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: UntypedFormGroup;

  portalMessage = '';
  returnUrl: string | null = null;
  slug: string | null = null;
  communityId: string | null = null;
  loadingSend = false;

  constructor(
    private fb: UntypedFormBuilder,
    private dataService: FreelancerDataService,
    private router: Router,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    public domainService: DomainService,
    private ngZone: NgZone,
  ) {}

  ngOnInit(): void {
    this.initializeForgotPasswordForm();

    const params = this.route.snapshot.params;

    this.slug = params['slug'] || localStorage.getItem('slug');
    this.communityId = params['communityId'] || localStorage.getItem('communityId');

    if (this.slug) localStorage.setItem('slug', this.slug);
    if (this.communityId) localStorage.setItem('communityId', this.communityId);

    const email = this.route.snapshot.queryParamMap.get('email');
    const message = this.route.snapshot.queryParamMap.get('message');
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

    this.returnUrl = returnUrl;

    if (email) {
      this.forgotPasswordForm.patchValue({
        email: decodeURIComponent(email),
      });
    }

    if (message) {
      this.portalMessage = message;
    }
  }

  initializeForgotPasswordForm(): void {
    this.forgotPasswordForm = this.fb.group({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });
  }

  sendOTP(): void {
    if (this.loadingSend || this.forgotPasswordForm.invalid) return;

    const email = String(this.forgotPasswordForm.value.email || '').trim();
    if (!email) return;

    this.loadingSend = true;

    this.dataService.sendOTP({
    email,
    brand: 'komudu',
  }).subscribe({
      next: (res: { data?: string }) => {
        this.loadingSend = false;

        this.toastrService.success(res?.data || 'OTP sent successfully.');

        const encoded = encodeURIComponent(email);
        const queryParams = this.returnUrl
          ? { returnUrl: this.returnUrl }
          : undefined;

        this.ngZone.run(() => {
          if (this.isCommunityForgotPasswordFlow()) {
            this.router.navigate(
              ['/', this.slug, this.communityId, 'reset-password', encoded],
              { queryParams }
            );
          } else {
            this.router.navigate(['/reset-password', encoded], { queryParams });
          }
        });
      },
      error: (err: any) => {
        this.loadingSend = false;

        this.toastrService.error(
          err?.error?.error?.description ||
            err?.error?.description ||
            'Failed to send OTP'
        );
      },
    });
  }

  backTosignIn(): void {
    const queryParams = this.returnUrl
      ? { returnUrl: this.returnUrl }
      : undefined;

    this.ngZone.run(() => {
      if (this.isCommunityForgotPasswordFlow()) {
        this.router.navigate([`/${this.slug}/${this.communityId}/login`], {
          queryParams,
        });
      } else {
        this.router.navigate(['/login'], {
          queryParams,
        });
      }
    });
  }

  private isCommunityForgotPasswordFlow(): boolean {
    return (
      this.domainService.isCommunityDomain() &&
      !!this.slug &&
      !!this.communityId
    );
  }
}